module.exports = __webpack_public_path__ + "img/Customer_Empathy_new_logo.cbc66efc.png";